import { createSlice } from "@reduxjs/toolkit";

// Retrieve token from sessionStorage to persist through page refreshes
const getInitialToken = () => {
  const storedToken = sessionStorage.getItem('auth_token');
  return storedToken || null;
};

const authSlice = createSlice({
  name: "auth",
  initialState: { 
    token: getInitialToken(),
    sessionExpired: false, // New flag to track if session expired
    sessionRecoveryAttempted: false // Track if we've tried to recover
  },
  reducers: {
    setCredentials: (state, action) => {
      const { accessToken } = action.payload;
      state.token = accessToken;
      
      // Reset session expired flag on successful login/refresh
      state.sessionExpired = false;
      
      // Store the token in sessionStorage to persist through page refreshes
      // Using sessionStorage instead of localStorage for better security (cleared when tab is closed)
      if (accessToken) {
        sessionStorage.setItem('auth_token', accessToken);
      }
    },
    logOut: (state, action) => {
      state.token = null;
      state.sessionExpired = false;
      state.sessionRecoveryAttempted = false;
      
      // Clean up stored tokens and session backups
      sessionStorage.removeItem('auth_token');
      localStorage.removeItem('session_backup');
    },
    // New action to handle expired sessions
    sessionExpired: (state, action) => {
      state.token = null;
      state.sessionExpired = true;
      state.sessionRecoveryAttempted = true;
      
      // Clear tokens since session is confirmed expired
      sessionStorage.removeItem('auth_token');
      localStorage.removeItem('session_backup');
    }
  },
});

export const { setCredentials, logOut, sessionExpired } = authSlice.actions;

export default authSlice.reducer;

export const selectCurrentToken = (state) => state.auth.token;